import React from 'react';

import {
  FloatingStyledDiv,
  NoResultsP,
  OptionButton,
} from './Autocomplete-styled-components';

interface OptionProps {
  option: {
    id: number | string;
    name: string;
    component?: React.ReactElement;
    isDisabled?: boolean;
    isLabel?: boolean;
  };
  hoveredOption: number | string | null;
  handleMouseEnter: () => void;
  handleSelect: () => void;
}

const Option = ({
  option: { id, name, component, isDisabled, isLabel },
  hoveredOption,
  handleMouseEnter,
  handleSelect,
}: OptionProps) =>
  component
  || (
    <OptionButton
      tabIndex={-1}
      type="button"
      data-option-id={id} // Used to scroll to option based on ID
      $isHovered={hoveredOption === id}
      disabled={isDisabled}
      $isLabel={Boolean(isLabel)}
      onMouseEnter={handleMouseEnter}
      onClick={handleSelect}
    >
      {name}
    </OptionButton>
  );
interface DropdownProps {
  options: OptionProps['option'][];
  filter: string | null;
  hoveredOption: number | string | null;
  handleMouseEnter: (id: OptionProps['option']['id']) => void;
  handleSelect: (id: OptionProps['option']['id']) => void;
}

export const Dropdown = ({
  options,
  filter,
  hoveredOption,
  handleMouseEnter,
  handleSelect,
}: DropdownProps) => (
  <FloatingStyledDiv tabIndex={-1}>
    {options?.map((option) => (
      <Option
        key={option.id}
        option={option}
        hoveredOption={hoveredOption}
        handleMouseEnter={() => handleMouseEnter(option.id)}
        handleSelect={() => handleSelect(option.id)}
      />
    ))}
    {!options?.length
      && <NoResultsP>No results found for "{filter}"</NoResultsP>}
  </FloatingStyledDiv>
);

